export default {
  en: {
    type: {
      booking: 'Booking',
      date: 'Date Finder',
      discussion: 'Discussion',
      engagement: 'Engagement',
      event: 'Event',
      internal: 'Forum post',
      marketplace: 'Marketplace',
      news: 'News',
      organize: 'Helper list',
      poll: 'Poll',
    },
  },
};
